module.exports = __webpack_public_path__ + "img/A-class.0f485eff.jpeg";